<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="1500px"
    title="合并"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    append-to-body
    top="5vh"
    draggable
  >
    <div class="content">
      <p class="header">请选择合并的基础信息</p>
      <div class="data">
        <BaseTable
          :tableData="{
            ...tableData,
            columns,
          }"
          height="519"
          :isPager="false"
          @handleSelectionChange="handleSelectionChange"
        >
        </BaseTable>
      </div>
    </div>
    <template slot="footer">
      <div class="footer flex_c_c">
        <div class="cancel flex_c_c" @click="cancel">取消</div>
        <div class="ok flex_c_c" @click="ok">确认</div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import BaseTable from '@/components/table/BaseTable.vue'

export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    mergeSelections: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'mark',
            label: 'MARK',
            width: '200px'
          },
          {
            filed: 'nameEN',
            label: 'Product name',
            width: '200px'
          },
          {
            filed: 'nameCH',
            label: '中文品名',
            width: '150px'
          },
          {
            filed: 'hsCode',
            label: 'HsCode',
            width: '160px'
          },
          {
            filed: 'material',
            label: 'Material',
            width: '200px'
          },
          {
            filed: 'usedFor',
            label: 'Used for',
            width: '200px'
          },
          {
            filed: 'packages',
            label: 'Ctns',
            width: '85px'
          },
          {
            filed: 'qty',
            label: 'Qty',
            width: '68px'
          },
          {
            filed: 'unitPrice',
            label: 'Unit price',
            width: '100px'
          },
          {
            filed: 'totalPrice',
            label: 'Total price',
            width: '100px'
          },
          {
            filed: 'netWeight',
            label: 'Net.W',
            width: '108px'
          },
          {
            filed: 'grossWeight',
            label: 'Gro.W',
            width: '108px'
          }
        ],
        columns: [],
        mutiCheck: true
      },
      selections: []
    }
  },
  computed: {
    columns() {
      return this.mergeSelections
    }
  },
  created() {},
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    ok() {
      if (this.selections.length === 0) {
        this.$message.error('请选择一项')
        return
      }
      let qty = 0
    let packages = 0
    let netWeight = 0
    let grossWeight = 0
    let totalPrice = 0 // 新增：用于记录总金额

    this.mergeSelections.forEach((item) => {
      qty += Number(item.qty)
      packages += Number(item.packages)
      netWeight += Number(item.netWeight)
      grossWeight += Number(item.grossWeight)
      totalPrice += Number(item.totalPrice) // 累加总价
    })

    const mergedItem = {
      ...this.selections[0], // 使用第一个选择项的其他属性作为基础
      qty,
      packages,
      netWeight,
      grossWeight,
      totalPrice, // 设置合并后的总价
      unitPrice: (totalPrice / qty).toFixed(3) // 根据总价和数量重新计算单价，并保留两位小数
    }

    this.$emit('ok', mergedItem)
    },
    handleSelectionChange(items) {
      this.selections = items
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  height: 594px;
  .header {
    width: 100%;
    height: 60px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    color: #142e79;
    line-height: 60px;
    text-align: center;
  }
  .data {
    height: 519px;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 5px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #cdcdcd;
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    margin-right: 16px;
    cursor: pointer;
  }
}
.footer {
  width: 100%;
  display: flex;
  justify-content: center !important;
  & > div {
    width: 120px;
    height: 40px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    align-content: center;
    box-sizing: border-box;
    & + div {
      margin-left: 20px;
    }
  }
  .ok {
    color: #ffffff;
    background: #142e79;
  }
  .cancel {
    border: 1px solid #dcdfe6;
  }
}
</style>
